import I18n from 'I18n';
import { PlaylistAssignmentsSearch, usePlaylistAssignmentsSearchContext, UnAssignPlaylistButton } from '..';
import { CardMenuOptions } from '../../cardMenu';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UIButton from 'UIComponents/button/UIButton';
import formatName from 'I18n/utils/formatName';
import { AvatarViewer } from '../../avatar';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnassignPlaylistHeader = () => {
  const {
    selectedPortalId,
    unselectPortal
  } = usePlaylistAssignmentsSearchContext();
  return selectedPortalId ? /*#__PURE__*/_jsxs(UIButton, {
    onClick: unselectPortal,
    use: "link",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "left"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.backLink"
    })]
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlistAssignments.unassignPlaylist"
  });
};
export const UnassignPlaylistLoadMore = () => {
  const {
    selectedPortalId
  } = usePlaylistAssignmentsSearchContext();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: selectedPortalId ? 'learningCenter.cardMenu.loadMoreAssignments' : 'learningCenter.cardMenu.loadMorePortals'
  });
};
const UnassignPlaylistPortalList = ({
  portals,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('learningCenter.playlistAssignments.portalsHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(UISideNavItem, {
    title: content
  }, key),
  onPortalClick
}) => {
  return renderList(portals && portals.map(({
    portal: {
      id,
      companyName
    },
    playlistId
  }) => {
    return renderRow( /*#__PURE__*/_jsx(UIButton, {
      onClick: () => {
        if (onPortalClick) onPortalClick(id);
      },
      style: {
        width: '100%'
      },
      use: "unstyled",
      children: companyName
    }), `portal_${playlistId}_${id}`);
  }));
};
const UnassignPlaylistAssignmentList = ({
  assignments,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('learningCenter.playlistAssignments.portalsHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(UISideNavItem, {
    title: content
  }, key),
  onAssignmentClick,
  onUnassigned
}) => {
  const handleOnUnassigned = (portalId, assignmentId) => {
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  return renderList(assignments && assignments.map(({
    playlistId,
    portalId,
    id,
    assignee: {
      avatarHash,
      firstName,
      lastName
    }
  }) => {
    const displayName = formatName({
      firstName,
      lastName
    });
    return renderRow( /*#__PURE__*/_jsx(UnAssignPlaylistButton, {
      assignments: [id],
      onDeleted: () => handleOnUnassigned(portalId, id),
      render: ({
        handleOnClick
      }) => /*#__PURE__*/_jsx(UIButton, {
        onClick: e => {
          handleOnClick(e);
          if (onAssignmentClick) onAssignmentClick(portalId, id);
        },
        style: {
          width: '100%'
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(UIFlex, {
          children: /*#__PURE__*/_jsx(AvatarViewer, {
            avatarHash: avatarHash,
            displayName: displayName,
            renderName: true,
            size: "xs",
            type: "contact"
          })
        })
      })
    }), `portal_${playlistId}_${portalId}_${id}`);
  }));
};
export const UnAssignPlaylist = ({
  playlistId,
  renderList,
  renderRow,
  loadMoreButton,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const {
    selectPortal
  } = usePlaylistAssignmentsSearchContext();
  const handleOnPortalClick = portalId => {
    selectPortal(portalId);
    if (onPortalClick) onPortalClick(portalId);
  };
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearch, {
    loadMoreButton: loadMoreButton,
    playlistId: playlistId,
    renderAssignments: assignments => assignments && /*#__PURE__*/_jsx(UnassignPlaylistAssignmentList, {
      assignments: assignments,
      onAssignmentClick: onAssignmentClick,
      onUnassigned: onUnassigned,
      renderList: renderList,
      renderRow: renderRow
    }),
    renderPortals: portals => portals && /*#__PURE__*/_jsx(UnassignPlaylistPortalList, {
      onPortalClick: handleOnPortalClick,
      portals: portals,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default UnAssignPlaylist;